import slaConfig from '../../components/Sla/slaConfig.json';
import messages from '../../blocks/CartV2/messages';
import { IncompatibilityRule } from '../cart/types';

/* eslint-disable import/prefer-default-export */
export const EMAIL_REGULAR_EXPRESSION =
  /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const PASSWORD_REGULAR_EXPRESSION = /^(?!.* ).{10,}$/;

export const FAILED_ORDER_STATUS = 'failed';
export const NOT_FOUND_ERROR_CODE = '404';

export const WARRANTY_CUSTOM_LINE_ITEM_TYPE = 'warranty';
export const DELIVERY_FEE_CUSTOM_LINE_ITEM_TYPE = 'deliveryFee';
// The Colorado retail delivery fee now arrives from Stripe as a tax portion
// (e.g. name "CO retail_delivery_fee") rather than a custom line item.
// Per CO tax law it must be broken out from taxes and displayed separately.
export const RETAIL_DELIVERY_FEE_TAX_PORTION_NAME = 'retail_delivery_fee';
export const AB_TEST_AFFIRM = {
  test1: {
    minPrice: 0,
    maxPrice: 99999,
    financingProgram: 'variant_zero_3_6_12',
  },
  test2: {
    minPrice: 100000,
    maxPrice: 179999,
    dataPromoId: 'promo_set_variant_zero_6_12_18_category',
    financingProgram: 'variant_zero_6_12_18',
  },
  test3: {
    minPrice: 180000,
    maxPrice: 239999,
    dataPromoId: 'promo_set_variant_zero_6_12_24_category',
    financingProgram: 'variant_zero_6_12_24',
  },
  test4: {
    minPrice: 240000,
    maxPrice: 259999,
    dataPromoId: 'promo_set_variant_zero_12_24_36_category',
    financingProgram: 'variant_zero_12_24_36',
  },
  test5: {
    minPrice: 260000,
    dataPromoId: 'promo_set_variant_zero_12_24_48_category',
    financingProgram: 'variant_zero_12_24_48',
  },
};
export const TITLE_ATTRIBUTE_NAME = 'title';

export const CUSTOMERCARE_PHONE = '800-456-7890';
export const BASE_URL = 'https://purple.com/';

export const RESTORE_PRODUCT_KEY = '3361b3d2-b893-46de-88e1-b6088ffd1370';
export const RESTORE_PREMIER_PRODUCT_KEY =
  'a778ba3d-2573-4891-b79c-80f51f25ed0a';
export const RESTORE_PLUS_PRODUCT_KEY = 'e65d2747-04d0-4494-971d-0d1a451b7cea';
export const RESTORE_PRODUCT_KEYS_ARRAY = [
  RESTORE_PRODUCT_KEY,
  RESTORE_PREMIER_PRODUCT_KEY,
  RESTORE_PLUS_PRODUCT_KEY,
];
export const REJUVENATE_PRODUCT_KEY = 'b83ca84f-7835-48bf-ae02-ab534dd1fae2';
export const REJUVENATE_PRODUCT_2023_KEY =
  'abaa562c-a640-4466-8eef-dfa7887ab932';
export const REJUVENATE_PLUS_PRODUCT_KEY =
  'a12bd1b5-0947-42f4-a2cb-cc5123a955a0';
export const REJUVENATE_PLUS_2023_PRODUCT_KEY =
  '15c64f96-8e9e-40ce-a067-434873174921';
export const REJUVENATE_PREMIER_PRODUCT_KEY =
  '626f6d9c-e178-48e5-a333-335d0fceb6bd';
export const REJUVENATE_PREMIER_2023_PRODUCT_KEY =
  '08a42027-07c7-4295-8ef9-d292c7e1c84e';
export const REJUVENATE_ULTIMATE_PRODUCT_KEY =
  'b61b670a-4886-410b-b1b5-db9e421d3fee';

export const REJUVENATE_COLLECTION_PRODUCT_KEYS = [
  REJUVENATE_PRODUCT_KEY,
  REJUVENATE_PRODUCT_2023_KEY,
  REJUVENATE_PLUS_PRODUCT_KEY,
  REJUVENATE_PLUS_2023_PRODUCT_KEY,
  REJUVENATE_PREMIER_PRODUCT_KEY,
  REJUVENATE_PREMIER_2023_PRODUCT_KEY,
  REJUVENATE_ULTIMATE_PRODUCT_KEY,
];

export const PRODUCT_KEYS_SHOW_STORE_LOCATOR_CTA = [
  ...RESTORE_PRODUCT_KEYS_ARRAY,
  ...REJUVENATE_COLLECTION_PRODUCT_KEYS,
];

export const RESTORE_AND_REJUVENATE_PRODUCT_KEYS = [
  ...RESTORE_PRODUCT_KEYS_ARRAY,
  ...REJUVENATE_COLLECTION_PRODUCT_KEYS,
];

export const ATTRIBUTE_VALUE_FEEL_FIRM = 'Firm';
export const ATTRIBUTE_VALUE_FEEL_SOFT = 'Soft';

export const STORE_LOCATOR_CTA_FEATURE_NAME = 'store_locator_cta';

export const ATTRIBUTE_DESCRIPTION_COOKIE = 'attribute_description_test';

export const SOFTSTRETCH_SHEET_SET = '06218d33-26e3-4b95-8f0a-224381463419';
export const COMPLETE_COMFORT_SHEET_SET =
  'a92f94e2-7621-486b-b73c-a8ed2325714f';
export const MATTRESS_PROTECTOR = 'de008b44-75fa-4e29-8932-1d21a417e974';
export const WATERPROOF_MATTRESS_PROTECTOR =
  'b5e7a162-479f-488b-897c-509ae2e3906f';
export const ADJUSTABLE_BASE = 'c81c818c-a448-4d5c-b30c-4191b31b9493';
export const ASCENT_ADJUSTABLE_BASE = '7c65c7b4-e345-4971-a567-b8c1c1078b2e';
export const PURPLE_PREMIUM_SMART_BASE = '1b4f69f5-f284-446f-931f-353768276ae2';
export const PURPLE_PREMIUM_PLUS_SMART_BASE =
  '19fd3026-b057-4f5f-80ce-8aeb255d6216';
export const PURPLE_HEADBOARD = '85941697-faf8-4b18-8541-f22e3422988b';
export const PURPLE_METAL_PLATFORM = '39be50f5-bc0d-415c-b908-7c5ef4c01067';

export const PURPLE_CLOUD_PILLOW = 'a6373a2b-6b25-44c6-baa3-f66e8bb4215e';

export const ALL_MATTRESS_PRODUCT_KEYS = slaConfig.mattress.map(
  (mattress) => mattress.key,
);

export const FEEL_ATTRIBUTE_NAME = 'feel';
export const FEEL_VARIANT_NAME_COOKIE = 'cart_feel_variant_name';
export const SOFT_VARIANT_TITLE = 'Soft |';
export const FIRM_VARIANT_TITLE = 'Firm |';
export const HOMEPAGE_REGULAR_EXPRESSION = /^(\/\d+|\/homepage(?!\/)|\/)$/;

export const IS_OUT_OF_STOCK = 'isOutOfStock';
export const IS_OUT_OF_STOCK_TRUE_KEY = 'true';
export const NO_LINK_TITLE = '<nolink>';
export const SLEEP_CONSULTANT_TITLE = 'Ask a sleep genius';
export const SUPPORT_TITLE = 'Support';
export const MOBILE_NAV_OPENER = 'mobile-nav-menu-icon';
export const SALE_TITLE = 'Sale';
export const SHOP_TITLE = 'Shop';
export const STORE_LOCATOR_URL = '/stores/';

export const ABANDONED_CART_PROMO_CODES_REGULAR_EXPRESSION = /^ABC/;

/**
 * CSE-655 — hide financing when the cart carries an employee discount code.
 *
 * Instant, deploy-free kill switch for the web behaviour. The backend has its
 * own switch (`EMPLOYEE_DISCOUNT_FINANCING_BLOCK_ENABLED` in orders-ms), but
 * that one needs a pod restart, so this is the lever for rolling back anything
 * customer-visible.
 */
export const BLOCK_FINANCING_FOR_EMPLOYEE_DISCOUNTS_TOGGLE =
  'block_financing_for_employee_discounts';

/**
 * Stripe payment method types that are financing.
 *
 * These render from the Stripe payment method configuration rather than from
 * `options.customPaymentMethods`, so gating React code cannot remove them —
 * they have to be named in `options.excludedPaymentMethodTypes`.
 *
 * Owned here rather than in @purple.com/component-library on purpose: this list
 * is Stripe Elements-specific and purple-drupal is the only surface that
 * renders Stripe Elements. mpos_web is card-present and orders-ms never sees a
 * Stripe payment method type. See component-library/CLAUDE.md#the-scope-rule.
 */
export const STRIPE_FINANCING_PAYMENT_METHOD_TYPES = [
  'affirm',
  'klarna',
  'afterpay_clearpay',
];
export const NEWDAY_TPM_PROMO = 'TPMFLEXUPGRADE';
export const PRODUCT_UPGRADE_TEST_COOKIE = 'product_upgrade_test';
export const IN_HOME_SETUP_QUALIFIED_SHIPPING_METHOD_KEY =
  'in-home-setup-qualified';
export const IN_HOME_SETUP_FREE_SHIPPING_METHOD_KEY = 'IN-HOME SETUP_FREE';
export const IN_HOME_SETUP_PAID_SHIPPING_METHOD_KEY = 'IN-HOME SETUP_PAID';
export const STANDARD_SHIPPING_KEY = 'FEDEX_GROUND';

export const CONFLICTING_PROMOS_TOAST_TYPE_10OFF_REMOVED = '10OffRemoved';
export const CONFLICTING_PROMOS_TOAST_TYPE_5OFF_REMOVED = '5OffRemoved';
export const CONFLICTING_PROMOS_TOAST_TYPE_10OFF_CANNOT_BE_APPLIED =
  '10OffCannotBeApplied';
export const CONFLICTING_PROMOS_TOAST_TYPE_5OFF_CANNOT_BE_APPLIED =
  '5OffCannotBeApplied';
export const CONFLICTING_PROMO_TOASTER_TYPE_TO_SHOW_SESSION_STORAGE_KEY =
  'conflictingPromoToasterTypeToShow';

export const SLA_RANGE_STANDARD_SHIPPING_7_10_DAYS = '7-10 days';

export const ITEM_LIST_IDS_TEALIUM = {
  cartQuickAdd: 'cart_quick_add',
  cartRecommendedProducts: 'cart_recommended_products',
  productDetailPage: 'product_detail_page',
  minicartAovDrivers: 'minicart_aov_drivers',
  bundleDetailPage: 'bundle_detail_page',
  productDetailPageAOV: 'product_page_aov_driver',
  cartQuantityIncrease: 'cart_quantity_increase',
  cartQuantityDecrease: 'cart_quantity_decrese',
  cartRemoveItem: 'cart_remove_item',
};
export const TEALIUM_ADDED_LOCATION_COOKIE = 'tealium_lineItem_details';
export const TEALIUM_IMPACT_READIUS_COOKIE = 'impactRadiusClickId';

export const CHARGE_AFTER_WIDGET_TAGS = {
  productLong: 'product-long',
  productShort: 'product-short',
  checkoutPayment: 'checkout-payment',
  banner: 'banner',
};

export const AFFIRM_MAXIMUM_CART_VALUE_CENTAMOUNT = 24000;
export const AFFIRM_MINIMUM_VALUE_CENTAMOUNT = 5000;
export const ACIMA_MAXIMUM_LEASE_CART_VALUE_CENTAMOUNT = 600000;
export const CHARGE_AFTER_MINIMUM_CART_VALUE_CENTAMOUNT = 10000;

// TODO: Charge After disabled
// export const CHARGE_AFTER_MINIMUM_PRODUCT_DISCOUNTED_PRICE_CENTAMOUNT = 10000000;
// TODO: Charge After Enabled:
export const CHARGE_AFTER_MINIMUM_PRODUCT_DISCOUNTED_PRICE_CENTAMOUNT = 24000;

export const CHARGE_AFTER_MINIMUM_PRD_DISCOUNTED_PRICE_FOR_LONGER_WIDGET_TEXT_CENTAMOUNT = 300000;
export const CHARGE_AFTER_STORE_ID_ECOMM = 'ECOMM';
export const CHARGE_AFTER_INSIDE_SALES_STORE_ID = 'UT-IS';
export const CHARGE_AFTER_CUSTOMER_CARE_STORE_ID = 'UT-CC';
export const CHARGE_AFTER_IN_SALES_STORE_ID = 'INSALES';
export const CHARGE_AFTER_CHANNEL_ECOMM = 'E_COMMERCE';
export const CHARGE_AFTER_CHANNEL_IN_STORE = 'IN_STORE';

export const CHARGE_AFTER_WIDGET_TYPES = {
  defaultTemplate: 'default-template',
};
export const DEFAULT_IN_HOME_SETUP_PRICE_CENT = 20000;
export const SIZE_ATTRIBUTE_NAME = 'size';

export const LAST_OFFERED_FULL_PRICE_DATE = 'last-offered-full-price-date';
export const MASTER_LAST_OFFERED_FULL_PRICE_DATE =
  'master-last-offered-full-price-date';

export const PILLOW_SIZE_NAME = 'pillow-size';
export const PILLOW_HEIGHT_NAME = 'pillow-height';
export const COLOR_NAME = 'color';
export const SHEET_TYPE = 'sheet-type';
export const DEPTH_ATTRIBUTE_NAME = 'depth';

export const MATTRESS_PRODUCT_TYPE_SINGULAR = 'mattress';
export const MATTRESSES_PRODUCT_TYPE = 'mattresses';
export const PILLOWS_PRODUCT_TYPE = 'pillows';

export const PILLOW_HEIGHT_MAP = {
  low: '5.5”',
  medium: '6.5”',
  tall: '7.5”',
};
export const VARIANT_ATTRIBUTE_NAME_COLOR_CODE = 'color-code';
export const PURPLE_FLEX_MATTRESS_PRODUCT_KEY =
  '58ea0ee7-bd9c-490e-95b7-524a704a77a6';

export const PURPLE_CLOUD_PILLOW_PRODUCT_KEY =
  'a6373a2b-6b25-44c6-baa3-f66e8bb4215e';

export const TWIN_SIZE_KEY = 'twin';

export const TWIN_XL_SIZE_KEY = 'twin_xl';
export const PRODUCT_TEST_UPGRADE_SKUS = ['10-21-23617', '10-21-23618'];

export const CHECKOUT_URLS = [
  '/checkout',
  '/stepped-checkout',
  '/draft-order/checkout',
];
export const FREE_GIFT_AOVS = 'Free Gifts';
export const COMPLETE_SET_AOVS = 'Complete Your Set';

export const STRIPE_REDIRECTION_IF_REQUIRED_FEATURE_TOGGLE =
  'stripe_redirection_if_required';
export const STRIPE_EXPRESS_CHECKOUT_FEATURE_TOGGLE = 'stripe_express_checkout';

export const AFFIRM_PRICE_LOWER_THRESHOLD = 5000;
export const AFFIRM_PRICE_UPPER_THRESHOLD = 3000000;
export const AFFIRM_PRICE_CONDITIONAL_THRESHOLD = 1750000;

export const WAIVE_IN_HOME_SETUP_FREE = 0;
export const PAID_IN_HOME_SETUP_FEE = 20000;

export const REJUVENATE_COLLECTION_SKU_EXCEPTIONS = [
  '10-38-22902', // Purple SoftStretch Sheet Set - Twin / Twin XL | Stormy Grey | Deep Pocket
  '10-38-22903', // Purple SoftStretch Sheet Set - Twin / Twin XL | Deep Purple | Deep Pocket
  '10-38-22904', // Purple SoftStretch Sheet Set - Twin / Twin XL | True White | Deep Pocket
  '10-38-22905', // Purple SoftStretch Sheet Set - Twin / Twin XL | Morning Mist | Deep Pocket
  '10-38-22906', // Purple SoftStretch Sheet Set - Queen | Stormy Grey | Deep Pocket
  '10-38-22907', // Purple SoftStretch Sheet Set - Queen | Deep Purple | Deep Pocket
  '10-38-22908', // Purple SoftStretch Sheet Set - Queen | True White | Deep Pocket
  '10-38-22909', // Purple SoftStretch Sheet Set - Queen | Morning Mist | Deep Pocket
  '10-38-22910', // Purple SoftStretch Sheet Set - King / Cal King | Stormy Grey | Deep Pocket
  '10-38-22911', // Purple SoftStretch Sheet Set - King / Cal King | Deep Purple | Deep Pocket
  '10-38-22912', // Purple SoftStretch Sheet Set - King / Cal King | True White | Deep Pocket
  '10-38-22913', // Purple SoftStretch Sheet Set - King / Cal King | Morning Mist | Deep Pocket
  '10-38-22914', // Purple SoftStretch Sheet Set - Split King | Stormy Grey | Deep Pocket
  '10-38-22915', // Purple SoftStretch Sheet Set - Split King | Deep Purple | Deep Pocket
  '10-38-22916', // Purple SoftStretch Sheet Set - Split King | True White | Deep Pocket
  '10-38-22917', // Purple SoftStretch Sheet Set - Split King | Morning Mist | Deep Pocket
  '10-38-12685', // Purple Waterproof Mattress Protector - Twin XL | Deep Pocket
  '10-38-12687', // Purple Waterproof Mattress Protector - Queen | Deep Pocket
  '10-38-12688', // Purple Waterproof Mattress Protector - King | Deep Pocket
  '10-38-12689', // Purple Waterproof Mattress Protector - Cal King | Deep Pocket
  '10-38-12691', // Purple Waterproof Mattress Protector - Split King | Deep Pocket
];

export const INCOMPATIBILITY_RULES: IncompatibilityRule[] = [
  {
    description:
      'Rejuvenate mattresses are incompatible with targetValue products. Exception SKUs are compatible. ' +
      'If a targetValue is incompatible with more than 1 sourceValue in the cart, multiWarningMessageOverride will be used.',
    sourceType: 'productKey',
    sourceValues: REJUVENATE_COLLECTION_PRODUCT_KEYS,
    targetType: 'productKey',
    targetValues: [
      SOFTSTRETCH_SHEET_SET,
      MATTRESS_PROTECTOR,
      COMPLETE_COMFORT_SHEET_SET,
      ADJUSTABLE_BASE,
      WATERPROOF_MATTRESS_PROTECTOR,
    ],
    exceptionType: 'sku',
    exceptionValues: REJUVENATE_COLLECTION_SKU_EXCEPTIONS,
    multiWarningMessageOverride:
      messages.multipleIncompatibleRejuvenateProductsWarning,
  },
  {
    description:
      'King Rejuvenate mattresses are incompatible with King Purple Premium [Plus] Smart Bases. ' +
      'warningMessageOverride will be used instead of the default message.',
    sourceType: 'sku',
    sourceValues: [
      '10-21-24168', // Rejuvenate Mattress - King
      '10-21-24172', // RejuvenatePlus Mattress - King
      '10-21-24176', // RejuvenatePremier Mattress - King
      '10-21-24180', // RejuvenateUltimate Mattress - King
    ],
    targetType: 'sku',
    targetValues: [
      '10-38-12987', // Purple Premium Smart Base - King
      '10-38-12991', // Purple Premium Plus Smart Base - King
    ],
    warningMessageOverride: messages.customPremiumBaseIncompatibilityMessage,
  },
  {
    description:
      'Standalone Headboard is incompatible with the Premium [Plus] Smart Base, Adjustable Base and Metal Platform. ' +
      'An additional warning message will be appended after the default warning message.',
    sourceType: 'productKey',
    sourceValues: [
      PURPLE_PREMIUM_PLUS_SMART_BASE,
      PURPLE_PREMIUM_SMART_BASE,
      ADJUSTABLE_BASE,
      PURPLE_METAL_PLATFORM,
    ],
    targetType: 'productKey',
    targetValues: [PURPLE_HEADBOARD],
    additionalWarningMessage: messages.customHeadboardIncompatibilityMessage,
  },
];
